export default __webpack_public_path__ + "static/media/GSRR_15.7cd0663b.svg";